import React, { useState, useEffect } from "react";

// components imports
import CreditCard from "../../Components/CreditCard/CreditCard";
import AddCard from "../../Components/AddBalance/AddCard";

// apis imports
import {
  deleteStripeCard,
  setDefaultCard,
  fetchCreditCards,
} from "../../../../../../../services/ShipperServices/Payments/payments.services";

// icons
import { MdAdd } from "react-icons/md";
import { useTranslation } from "react-i18next";

const CardManagement = ({ setSnack }) => {
  const { t } = useTranslation("finances");
  const [settingDefault, setSettingDefault] = useState(null);
  const [Cards, setCards] = useState(null);
  const [deleteLoader, setdeleteLoader] = useState(false);
  const [loadingCards, setLoadingCards] = useState(true);

  const [addCardModal, setAddCardModal] = useState(false);

  const getAllShippersTransections = async () => {
    setLoadingCards(true);
    const response = await fetchCreditCards();
    if (!response.error) {
      setCards(response.data.result?.payment_methods || []);
    } else {
      setSnack((snack) => ({
        ...snack,
        open: true,
        text: t("common:messages.somethingWentWrong"),
        severity: "error",
      }));
    }
    setLoadingCards(false);
  };

  useEffect(() => {
    getAllShippersTransections();
  }, []);

  const handleDeleteCard = async (id) => {
    setdeleteLoader(true);
    try {
      await deleteStripeCard(id);

      setCards((methods) => methods.filter((method) => method.id !== id));

      setSnack((snack) => ({
        ...snack,
        open: true,
        text: t("card.deleted"),
        severity: "success",
      }));
    } catch (error) {
      setSnack((snack) => ({
        ...snack,
        open: true,
        text: t("common:messages.somethingWentWrong"),
        severity: "error",
      }));
    }
    setdeleteLoader(false);
  };

  const handleDefaultCard = async (id) => {
    setSettingDefault(id);
    try {
      await setDefaultCard(id);

      setCards((methods) =>
        methods.map((method) => ({
          ...method,
          card: {
            ...method.card,
            is_default: method.id === id,
          },
        }))
      );

      setSnack((snack) => ({
        ...snack,
        open: true,
        text: t("card.defaultChanged"),
        severity: "success",
      }));
    } catch (error) {
      setSnack((snack) => ({
        ...snack,
        open: true,
        text: t("common:messages.somethingWentWrong"),
        severity: "error",
      }));
    }
    setSettingDefault(null);
  };

  return (
    <>
      {/* Card Container */}
      <div className="flex flex-wrap gap-4 mt-4">
        {/* Skeleton Loader */}
        {loadingCards &&
          [1, 2].map((i) => (
            <div
              key={i}
              className="h-36 w-[280px] rounded-xl bg-ui-border animate-pulse"
            ></div>
          ))}

        {/* Render existing cards */}
        {!loadingCards &&
          Cards.map((method) => (
            <CreditCard
              key={method.id}
              id={method.id}
              last_digits={method.card.last4}
              brand={method.card.brand}
              exp_year={method.card.exp_year}
              exp_month={method.card.exp_month}
              isDefault={method.card.is_default}
              handleDefaultCard={handleDefaultCard}
              handleDeleteCard={handleDeleteCard}
              deleteLoader={deleteLoader}
              loading={settingDefault === method.id}
              total={Cards.length}
            />
          ))}

        {/* Add Card Button as a card */}
        <div
          className="flex items-center justify-center gap-2 h-36 w-[280px] rounded-xl border-2 border-dashed border-ui-border cursor-pointer hover:border-brand hover:bg-brand-light transition text-ui-text"
          onClick={() => setAddCardModal(true)}
        >
          <MdAdd size={24} />
          <span className="font-semibold text-sm">{t("card.addNew")}</span>
        </div>
      </div>

      {/* Add Card Modal */}
      {addCardModal && (
        <AddCard
          open={addCardModal}
          setOpen={setAddCardModal}
          setCards={setCards}
        />
      )}
    </>
  );
};

export default CardManagement;
